/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
function n(n,...t){let r="";for(let o=0;o<t.length;o++)r+=n[o]+t[o];return r+=n[n.length-1],r}function t(n,t,r=""){return n?t:r}!function(n){function t(n){return Math.round(n).toString()}function r(n){return n.toPrecision(8)}n.int=t,n.float=r}(n);export{t as If,n as glsl};
